import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlSerializer, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { getLoggedIn, getPending, AuthState } from '../store';
import { tap, filter, take, switchMap, map } from 'rxjs/operators';
import { AuthService } from "../services/auth.service";

@Injectable({
    providedIn: 'root'
})
export class LoggedInGuard  {

    constructor(
        private store: Store<AuthState>,
        private router: Router,
        private urlSer: UrlSerializer,
        private authServ: AuthService
    ) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        return this.checkPending().pipe(
            switchMap(() => {
                const queryParams = next.queryParams
                if (queryParams.return_url)
                    return of(false);
                return this.checkLoggedIn();
            }),
            map(loggedIn => {
              if (!next.queryParams.token && loggedIn) {
                console.log('THIS IS IT?!?!?!');
                // http://localhost:4200/report/EC9388E0-AC0A-11EF-8C11-BD3C89BFBA1E/linescore
                let redirectUrl: string = this.authServ.redirectUrl;
                // FIXME: Why is this 'null'????!?!?
                console.log(typeof redirectUrl, redirectUrl);
                if (redirectUrl === 'null')
                  redirectUrl = null;
                // sessionStorage.removeItem('redirectUrl');

                // this.router.navigate([redirectUrl ?? '/']);
                const urlTree = this.urlSer.parse(redirectUrl ?? '/');
                return urlTree;
              }

                if (next.queryParams.token) {
                    return true;
                }

                return !loggedIn;
            })
        )
    }

    checkLoggedIn(): Observable<boolean> {
        return this.store.pipe(
            select(getLoggedIn),
            take(1)
        );
    }

    checkPending(): Observable<boolean> {
        return this.store.select(getPending).pipe(
            filter(pending => !pending),
            take(1)
        );
    }

}
